var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutions3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 320,
    viewBox: "0 0 228 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 320,
    rx: 20,
    fill: "#ECFFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.82 286.98L26.74 286.3H30.38C31.3667 286.3 32.1533 286.133 32.74 285.8C33.3267 285.453 33.7467 284.953 34 284.3C34.2667 283.647 34.4 282.847 34.4 281.9C34.4 280.86 34.26 280.033 33.98 279.42C33.7 278.807 33.26 278.367 32.66 278.1C32.06 277.833 31.26 277.7 30.26 277.7H26.98L27.82 276.6V286.98ZM25.74 288V276H30.52C31.8933 276 33.0133 276.213 33.88 276.64C34.76 277.067 35.4067 277.72 35.82 278.6C36.2467 279.467 36.46 280.567 36.46 281.9C36.46 283.233 36.2133 284.353 35.72 285.26C35.24 286.167 34.5533 286.853 33.66 287.32C32.7667 287.773 31.7133 288 30.5 288H25.74ZM40.4189 276H48.0589V277.68H40.4189V276ZM40.3189 286.32H48.0189V288H40.3189V286.32ZM40.2789 282.74V281.06H47.4189V282.74H40.2789ZM41.5989 288H39.5189V276H41.5989V288ZM58.3809 286C58.4609 285.653 58.5543 285.267 58.6609 284.84C58.7809 284.4 58.9009 283.947 59.0209 283.48C59.1543 283 59.2809 282.547 59.4009 282.12C59.5343 281.68 59.6543 281.32 59.7609 281.04L61.6609 276H65.1009V288H63.0409V282.28C63.0409 281.667 63.0476 281 63.0609 280.28C63.0743 279.56 63.0876 278.873 63.1009 278.22C63.1276 277.553 63.1409 276.993 63.1409 276.54L63.6209 277.68H62.1009L62.7409 276.46C62.6076 277.02 62.4476 277.627 62.2609 278.28C62.0876 278.933 61.8943 279.6 61.6809 280.28C61.4809 280.96 61.2543 281.627 61.0009 282.28L59.2409 286.6H57.0409L55.3609 282.2C55.1209 281.507 54.9009 280.827 54.7009 280.16C54.5009 279.493 54.3209 278.853 54.1609 278.24C54.0009 277.613 53.8543 277.02 53.7209 276.46L54.3009 277.68H52.9209L53.3409 276.52C53.3676 277 53.3809 277.567 53.3809 278.22C53.3809 278.873 53.3809 279.56 53.3809 280.28C53.3809 280.987 53.3809 281.653 53.3809 282.28V288H51.5009V276H55.1209L56.9209 281.1C57.0143 281.367 57.1276 281.713 57.2609 282.14C57.3943 282.567 57.5343 283.027 57.6809 283.52C57.8276 284 57.9609 284.46 58.0809 284.9C58.2009 285.34 58.2943 285.7 58.3609 285.98L57.5809 284.68H59.0209L58.3809 286ZM73.9913 288.24C73.0313 288.24 72.1846 288.1 71.4513 287.82C70.7179 287.54 70.1113 287.133 69.6313 286.6C69.1513 286.053 68.7846 285.393 68.5313 284.62C68.2913 283.847 68.1713 282.967 68.1713 281.98C68.1713 280.647 68.3913 279.52 68.8313 278.6C69.2846 277.68 69.9446 276.98 70.8113 276.5C71.6779 276.007 72.7379 275.76 73.9913 275.76C74.9379 275.76 75.7713 275.9 76.4913 276.18C77.2246 276.447 77.8313 276.847 78.3113 277.38C78.8046 277.913 79.1779 278.567 79.4313 279.34C79.6846 280.113 79.8113 280.993 79.8113 281.98C79.8113 283.287 79.5913 284.413 79.1513 285.36C78.7113 286.293 78.0646 287.007 77.2113 287.5C76.3579 287.993 75.2846 288.24 73.9913 288.24ZM73.9713 286.52C74.9046 286.52 75.6446 286.333 76.1913 285.96C76.7379 285.587 77.1313 285.06 77.3713 284.38C77.6246 283.7 77.7513 282.9 77.7513 281.98C77.7513 281.033 77.6246 280.233 77.3713 279.58C77.1313 278.913 76.7379 278.407 76.1913 278.06C75.6446 277.7 74.9113 277.52 73.9913 277.52C73.0846 277.52 72.3513 277.7 71.7913 278.06C71.2446 278.407 70.8446 278.913 70.5913 279.58C70.3513 280.247 70.2313 281.047 70.2313 281.98C70.2313 282.9 70.3513 283.7 70.5913 284.38C70.8446 285.06 71.2379 285.587 71.7713 285.96C72.3179 286.333 73.0513 286.52 73.9713 286.52Z",
    fill: "#0F1936"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1182_7578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 30,
    width: 180,
    height: 160
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 180,
    height: 160,
    rx: 15,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1182_7578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.113 89.5763L82.1921 46.6382C81.6213 46.3094 81.0097 46.4532 80.5205 46.6382C79.9904 46.8643 78.4614 47.7893 78.4614 47.7893L79.9496 50.7491L79.9904 114.077C79.9904 116.091 81.234 118.455 82.7222 119.339L155.012 163.613C155.012 163.613 157.071 162.544 157.724 162.154C158.376 161.763 158.702 160.92 158.702 159.831L158.825 94.8176C158.825 92.8033 157.581 90.4395 156.073 89.5557L156.113 89.5763Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.115 163.572L80.1943 120.634C78.7673 119.812 77.6052 117.571 77.6052 115.639L77.5645 49.9271C77.5645 47.995 78.7265 47.1112 80.1535 47.9539L154.075 90.8919C155.502 91.7141 156.664 93.9545 156.664 95.8866L156.705 159.667C156.705 161.599 155.543 164.415 154.115 163.572Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.037 155.618L83.2319 116.235C82.5999 115.865 82.1106 114.899 82.1106 114.057L82.0698 56.7511C82.0698 55.9084 82.5795 55.5179 83.1911 55.8878L150.996 95.27C151.628 95.6399 152.118 96.606 152.118 97.4487L152.158 154.754C152.158 155.597 151.649 155.988 151.037 155.618Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.722 99.9563C101.722 104.19 102.517 107.335 103.924 110.357C105.27 113.255 107.104 115.824 109.449 117.982C111.732 120.079 114.301 121.662 117.338 122.361C120.111 122.998 122.802 122.854 125.35 121.477C127.572 120.264 129.142 118.435 130.161 116.133C131.201 113.83 131.568 111.364 131.466 108.856C131.222 103.8 129.428 99.3191 126.37 95.3316C124.331 92.68 121.844 90.5629 118.827 89.1447C116.849 88.2198 114.79 87.6648 112.609 87.7676C108.368 87.932 105.29 89.9874 103.333 93.7694C102.171 95.9893 101.722 98.3942 101.722 99.9974V99.9563Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.978 110.48V94.4067L124.779 110.912L110.978 110.48Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.791 133.117L128.225 135.892L142.658 174.945L147.225 172.17L142.74 159.715L145.818 164.689L150.385 161.914L132.791 133.117Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.225 135.892V164.627L133.709 161.708L137.684 174.945H142.658L138.724 162.058L145.818 164.689L128.225 135.892Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.623 133.159H123.823",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.488 123.704V127.958",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.026 125.677L126.86 128.822",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.373 133.159H139.174",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.949 125.677L136.116 128.822",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.782 58.6009C131.568 42.4452 161.209 41.4174 173.951 57.8815C189.119 77.5109 174.583 114.529 141.455 140.551C108.327 166.573 69.1852 171.814 54.0177 152.185C40.2772 134.446 50.8782 102.443 77.564 77.2231",
    stroke: "#0F1936",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions3);
export default __webpack_public_path__ + "static/media/solutions3.293e24e2ee96f1384803b7d9b0278077.svg";
export { ForwardRef as ReactComponent };